export enum OnboardingFlow {
  OssAgent = 'oss-agent',
}
